import React from 'react';

import './loader.css';

export default function Loader() {
  return (
    <div className="bouncing-loader">
      <div />
      <div />
      <div />
    </div>
  );
}
